var map = {
	"./AchievePopup.png": 1230,
	"./AlertlSelectionClose.png": 1231,
	"./AlertlSelectionLogo.png": 1232,
	"./AlertlSelection_title.png": 1233,
	"./CH_copy.png": 1234,
	"./Choose_sB.png": 1235,
	"./Choose_sBtn.png": 1236,
	"./Choose_sN.png": 1237,
	"./Choose_sY.png": 1238,
	"./CircleB.png": 408,
	"./CircleG.png": 409,
	"./CircleR.png": 410,
	"./EN_copy.png": 1239,
	"./EVIgarten-web_banner.jpg": 2523,
	"./Group 595.png": 1240,
	"./Group 596.png": 1241,
	"./Group 598.png": 1242,
	"./Group 8266.png": 655,
	"./Group 8267.png": 518,
	"./Group 8268.png": 837,
	"./Group 9001.png": 838,
	"./Group 9083.png": 1243,
	"./Group1.png": 1244,
	"./Group2.png": 1245,
	"./Group3.png": 1246,
	"./MaskGroup.png": 1247,
	"./MaskGroup23.png": 656,
	"./Path 10891.png": 839,
	"./Path 831.png": 1248,
	"./Path 832.png": 1249,
	"./Path 833.png": 1250,
	"./Sound.png": 1251,
	"./Summer_Banner.png": 1252,
	"./WebApp/EVIFamily.png": 840,
	"./WebApp/EVIGARTEN.png": 841,
	"./achieve1.png": 1253,
	"./achieve2.png": 1254,
	"./achieve2_1.png": 657,
	"./achieve2_2.png": 658,
	"./achieve2_3.png": 659,
	"./achieve2_4.png": 660,
	"./achieve2_5.png": 661,
	"./achieve2_6.png": 662,
	"./achieve3.png": 1255,
	"./achieve4.png": 1256,
	"./achieve_icon.png": 1257,
	"./achieve_title.png": 842,
	"./achieve_title_en.png": 843,
	"./achievement.png": 411,
	"./achievement/button_cert_cn.png": 844,
	"./achievement/button_cert_english.png": 845,
	"./achievement/button_cert_zh.png": 846,
	"./achievement_01.png": 265,
	"./achievement_02.png": 266,
	"./achievement_03.png": 331,
	"./achievement_04.png": 332,
	"./addCourseBorder.png": 1258,
	"./arena.png": 1259,
	"./background.png": 1260,
	"./banner/1_english.png": 1261,
	"./banner/1_zh.png": 1262,
	"./banner/2022backtoschool.png": 1263,
	"./banner/2022backtoschool_en.png": 1264,
	"./banner/EVIGarten_en.png": 1265,
	"./banner/EVIGarten_zh.png": 1266,
	"./banner/capsule_machine_en.png": 663,
	"./banner/capsule_machine_en_ori.png": 1267,
	"./banner/capsule_machine_en_ori_2.png": 1268,
	"./banner/capsule_machine_en_ori_3.png": 1269,
	"./banner/capsule_machine_hk.png": 664,
	"./banner/capsule_machine_hk_ori.png": 1270,
	"./banner/capsule_machine_hk_ori_3.png": 1271,
	"./banner/capsule_machine_ori_2.png": 1272,
	"./banner/landing/1_english.png": 847,
	"./banner/landing/1_zh.png": 848,
	"./banner/landing/3_cn.png": 849,
	"./banner/landing/3_english.png": 850,
	"./banner/landing/3_zh.png": 851,
	"./banner/landing/4.png": 852,
	"./bg.png": 223,
	"./bg1.jpg": 2524,
	"./bg2.jpg": 2525,
	"./bg3.jpg": 2526,
	"./blackboard.png": 1273,
	"./blackboardf.png": 1274,
	"./blackboardh.png": 1275,
	"./button/intranet_cn.png": 1276,
	"./button/intranet_english.png": 1277,
	"./button/intranet_zh.png": 1278,
	"./button/kid_icon.png": 485,
	"./button/kids_cn.png": 1279,
	"./button/kids_english.png": 1280,
	"./button/kids_zh.png": 1281,
	"./button/login_cn.png": 1282,
	"./button/login_english.png": 1283,
	"./button/login_zh.png": 1284,
	"./button/meetings_cn.png": 1285,
	"./button/meetings_english.png": 1286,
	"./button/meetings_zh.png": 1287,
	"./button/notification.svg": 1452,
	"./button/parent_cn.png": 1288,
	"./button/parent_english.png": 1289,
	"./button/parent_icon.png": 326,
	"./button/parent_zh.png": 1290,
	"./button/zoom_icon.png": 1291,
	"./cantoneseOpera/1.png": 412,
	"./cantoneseOpera/2.png": 516,
	"./cantoneseOpera/4.png": 413,
	"./cantoneseOpera/5.png": 665,
	"./cantoneseOpera/EVIGARTENICON.jpg": 1009,
	"./cantoneseOpera/VOCABicon.png": 853,
	"./cantoneseOpera/cantonese_opera_teacherGuide.png": 666,
	"./cantoneseOpera/games.png": 667,
	"./cantoneseOpera/iconv3.png": 854,
	"./cantoneseOpera/parent.jpg": 2527,
	"./chinese_new_year_2022.png": 1292,
	"./circle icon-1.png": 1293,
	"./circle icon-1_new.png": 1294,
	"./circle icon-2.png": 1295,
	"./circle icon-2_new.png": 1296,
	"./circle icon-3.png": 1297,
	"./circle icon-3_new.png": 1298,
	"./circle icon-4.png": 1299,
	"./circle icon-5.png": 1300,
	"./close.png": 1301,
	"./cmt_icon1.png": 1302,
	"./cmt_icon2.png": 1303,
	"./cmt_icon3.png": 1304,
	"./cmt_icon4.png": 1305,
	"./course.png": 1306,
	"./course1.png": 1307,
	"./course2.png": 1308,
	"./course24.png": 1309,
	"./course3.png": 1310,
	"./course4.png": 1311,
	"./course5.png": 1312,
	"./course_new.png": 1313,
	"./cross.gif": 2528,
	"./drWong/K2.png": 1314,
	"./drWong/K3.png": 1315,
	"./drWong/info.svg": 2529,
	"./drWong/item1.png": 855,
	"./drWong/item2.png": 856,
	"./drWong/item3.png": 857,
	"./drWong/item4.png": 858,
	"./drWong/k1_bready.png": 1316,
	"./drWong/k1bg.png": 668,
	"./drWong/k2_dragon.png": 1317,
	"./drWong/k3_kitten.png": 1318,
	"./drWong/multi/audio.png": 859,
	"./drWong/multi/title.png": 860,
	"./drWong/title.png": 861,
	"./drWong/title1.png": 1319,
	"./drWong/vocab/cantonese_zh.png": 588,
	"./drWong/vocab/cn/vocab_icon.png": 486,
	"./drWong/vocab/english/vocab_icon.png": 487,
	"./drWong/vocab/english_english.png": 589,
	"./drWong/vocab/footer.png": 590,
	"./drWong/vocab/header.png": 591,
	"./drWong/vocab/putonghua_cn.png": 592,
	"./drWong/vocab/putonghua_cn_my.png": 593,
	"./drWong/vocab/putonghua_zh.png": 594,
	"./drWong/vocab/return.png": 488,
	"./drWong/vocab/stroke_order.png": 489,
	"./drWong/vocab/zh/vocab_icon.png": 490,
	"./efun.png": 862,
	"./emoji1.png": 863,
	"./emoji2.png": 864,
	"./emoji3.png": 865,
	"./emoji4.png": 866,
	"./emoji5.png": 867,
	"./emoji6.png": 868,
	"./exploration.png": 1320,
	"./exploration1.png": 1321,
	"./exploration2.png": 1322,
	"./exploration21.png": 1323,
	"./explore360/cn/exploring_fun.png": 869,
	"./explore360/cn/extend.png": 870,
	"./explore360/cn/mc.png": 871,
	"./explore360/cn/movie.png": 872,
	"./explore360/cn/story.png": 873,
	"./explore360/cn/vocab.png": 874,
	"./explore360/english/exploring_fun.png": 875,
	"./explore360/english/extend.png": 876,
	"./explore360/english/mc.png": 877,
	"./explore360/english/movie.png": 878,
	"./explore360/english/story.png": 879,
	"./explore360/english/vocab.png": 880,
	"./explore360/zh/exploring_fun.png": 595,
	"./explore360/zh/extend.png": 596,
	"./explore360/zh/mc.png": 597,
	"./explore360/zh/movie.png": 598,
	"./explore360/zh/story.png": 599,
	"./explore360/zh/vocab.png": 600,
	"./fishgame/fish.png": 1324,
	"./fishgame/fish_cn.png": 1325,
	"./fishgame/fish_english.png": 1326,
	"./fishgame/fish_zh.png": 1327,
	"./footer_border.png": 1328,
	"./goSchoolZone_english.png": 1329,
	"./goSchoolZone_zh.png": 1330,
	"./head/0.png": 881,
	"./head/1.png": 882,
	"./head/10.png": 883,
	"./head/11.png": 884,
	"./head/12.png": 885,
	"./head/13.png": 886,
	"./head/14.png": 887,
	"./head/15.png": 888,
	"./head/16.png": 889,
	"./head/17.png": 890,
	"./head/18.png": 891,
	"./head/19.png": 892,
	"./head/2.png": 893,
	"./head/3.png": 894,
	"./head/4.png": 895,
	"./head/5.png": 896,
	"./head/6.png": 897,
	"./head/7.png": 898,
	"./head/8.png": 899,
	"./head/9.png": 900,
	"./icon/apk_download.png": 901,
	"./icon/btn-download-android.png": 902,
	"./icon/btn-download-iphone.png": 903,
	"./integral/history_title.png": 1331,
	"./jt1.png": 1332,
	"./jt10.png": 1333,
	"./jt2.png": 1334,
	"./jt3.png": 1335,
	"./jt4.png": 1336,
	"./jt5.png": 1337,
	"./jt6.png": 1338,
	"./jt7.png": 1339,
	"./jt8.png": 1340,
	"./jt9.png": 1341,
	"./landing/banner/20191117.jpg": 1453,
	"./landing/change_01.jpg": 1454,
	"./landing/change_02.jpg": 1455,
	"./landing/change_03.jpg": 1456,
	"./landing/change_04.jpg": 1457,
	"./landing/change_05.jpg": 1458,
	"./landing/chinese_01.jpg": 1459,
	"./landing/chinese_02.jpg": 1460,
	"./landing/chinese_03.jpg": 1461,
	"./landing/chinese_04.jpg": 1462,
	"./landing/chinese_05.jpg": 1463,
	"./landing/cn/chinese_01.jpg": 1464,
	"./landing/cn/chinese_02.jpg": 1465,
	"./landing/cn/chinese_03.jpg": 1466,
	"./landing/cn/chinese_04.jpg": 1467,
	"./landing/cn/chinese_05.jpg": 1468,
	"./landing/cn/course_01.jpg": 1469,
	"./landing/cn/course_02.jpg": 1470,
	"./landing/cn/course_03.jpg": 1471,
	"./landing/cn/course_04.jpg": 1472,
	"./landing/cn/course_05.jpg": 1473,
	"./landing/cn/explore_01.jpg": 1474,
	"./landing/cn/explore_02.jpg": 1475,
	"./landing/cn/explore_03.jpg": 1476,
	"./landing/cn/explore_04.jpg": 1477,
	"./landing/cn/explore_05.jpg": 1478,
	"./landing/cn/festival_01.jpg": 1479,
	"./landing/cn/festival_02.jpg": 1480,
	"./landing/cn/festival_03.jpg": 1481,
	"./landing/cn/festival_04.jpg": 1482,
	"./landing/cn/festival_05.jpg": 1483,
	"./landing/cn/phonics_01.jpg": 1484,
	"./landing/cn/phonics_02.jpg": 1485,
	"./landing/cn/phonics_03.jpg": 1486,
	"./landing/cn/phonics_04.jpg": 1487,
	"./landing/course_01.jpg": 1488,
	"./landing/course_02.jpg": 1489,
	"./landing/course_03.jpg": 1490,
	"./landing/course_04.jpg": 1491,
	"./landing/course_05.jpg": 1492,
	"./landing/en/change_01.jpg": 1493,
	"./landing/en/change_02.jpg": 1494,
	"./landing/en/change_03.jpg": 1495,
	"./landing/en/change_04.jpg": 1496,
	"./landing/en/change_05.jpg": 1497,
	"./landing/en/chinese_01.jpg": 1498,
	"./landing/en/chinese_02.jpg": 1499,
	"./landing/en/chinese_03.jpg": 1500,
	"./landing/en/chinese_04.jpg": 1501,
	"./landing/en/chinese_05.jpg": 1502,
	"./landing/en/course_01.jpg": 1503,
	"./landing/en/course_02.jpg": 1504,
	"./landing/en/course_03.jpg": 1505,
	"./landing/en/course_04.jpg": 1506,
	"./landing/en/course_05.jpg": 1507,
	"./landing/en/explore_01.jpg": 1508,
	"./landing/en/explore_02.jpg": 1509,
	"./landing/en/explore_03.jpg": 1510,
	"./landing/en/explore_04.jpg": 1511,
	"./landing/en/explore_05.jpg": 1512,
	"./landing/en/festival_01.jpg": 1513,
	"./landing/en/festival_02.jpg": 1514,
	"./landing/en/festival_03.jpg": 1515,
	"./landing/en/festival_04.jpg": 1516,
	"./landing/en/festival_05.jpg": 1517,
	"./landing/en/phonics_01.jpg": 1518,
	"./landing/en/phonics_02.jpg": 1519,
	"./landing/en/phonics_03.jpg": 1520,
	"./landing/en/phonics_04.jpg": 1521,
	"./landing/en/story_01.jpg": 1522,
	"./landing/en/story_02.jpg": 1523,
	"./landing/en/story_03.jpg": 1524,
	"./landing/en/story_04.jpg": 1525,
	"./landing/en/story_05.jpg": 1526,
	"./landing/explore_01.jpg": 1527,
	"./landing/explore_02.jpg": 1528,
	"./landing/explore_03.jpg": 1529,
	"./landing/explore_04.jpg": 1530,
	"./landing/explore_05.jpg": 1531,
	"./landing/festival_01.jpg": 1532,
	"./landing/festival_02.jpg": 1533,
	"./landing/festival_03.jpg": 1534,
	"./landing/festival_04.jpg": 1535,
	"./landing/festival_05.jpg": 1536,
	"./landing/phonics_01.jpg": 1537,
	"./landing/phonics_02.jpg": 1538,
	"./landing/phonics_03.jpg": 1539,
	"./landing/phonics_04.jpg": 1540,
	"./landing/story_01.jpg": 1541,
	"./landing/story_02.jpg": 1542,
	"./landing/story_03.jpg": 1543,
	"./landing/story_04.jpg": 1544,
	"./landing/story_05.jpg": 1545,
	"./landing_banner2.png": 1342,
	"./landing_banner_cn.png": 1343,
	"./landing_banner_english.png": 1344,
	"./landing_banner_zh.png": 1345,
	"./landing_course1.jpg": 2530,
	"./landing_course2.jpg": 2531,
	"./landing_course3.jpg": 2532,
	"./landing_course4.jpg": 2533,
	"./landing_course5.png": 1346,
	"./logintime.png": 1347,
	"./logo.png": 264,
	"./logo_s.png": 330,
	"./logo_s120.png": 904,
	"./logo_s_border.png": 1348,
	"./love.png": 1349,
	"./loveactive.png": 1350,
	"./message.png": 1351,
	"./message_btn_03.png": 1352,
	"./model1.png": 1353,
	"./more_03.png": 905,
	"./newRegister/Group1.png": 906,
	"./newRegister/Group2.png": 907,
	"./newRegister/Group3.png": 908,
	"./newRegister/Group4.png": 909,
	"./newRegister/addChildren/cn/price.png": 910,
	"./newRegister/addChildren/cn/price_free.png": 911,
	"./newRegister/addChildren/english/price.png": 912,
	"./newRegister/addChildren/english/price_free.png": 913,
	"./newRegister/addChildren/zh/price.png": 914,
	"./newRegister/addChildren/zh/price_free.png": 915,
	"./newRegister/parent_logo.png": 601,
	"./news_icon1.gif": 2534,
	"./news_icon2.gif": 2535,
	"./news_icon3.gif": 2536,
	"./news_icon4.gif": 2537,
	"./noimage.jpg": 1447,
	"./pHome_article.png": 1354,
	"./pHome_banner.jpg": 1008,
	"./pageIcon1.png": 1355,
	"./pageIcon2.png": 1356,
	"./pageIcon3.png": 669,
	"./pageIcon4.png": 1357,
	"./pageIcon5.png": 1358,
	"./pageIcon6.png": 670,
	"./parent/banner.jpg": 1010,
	"./parent/banner2.jpg": 2538,
	"./parent/banner3.jpg": 1011,
	"./parent/ceo_banner_cn.png": 1359,
	"./parent/ceo_banner_english.png": 1360,
	"./parent/ceo_banner_zh.png": 1361,
	"./parent/ceo_cn.png": 1362,
	"./parent/ceo_english.png": 1363,
	"./parent/ceo_title_cn.png": 1364,
	"./parent/ceo_title_english.png": 1365,
	"./parent/ceo_title_zh.png": 1366,
	"./parent/ceo_zh.png": 1367,
	"./parent/plan_cn.png": 916,
	"./parent/plan_english.png": 917,
	"./parent/plan_zh.png": 918,
	"./parent_logo.png": 1368,
	"./payment/paypal-visa.jpg": 1546,
	"./payment/paypal.jpg": 1547,
	"./personal/Group 9801.png": 1369,
	"./personal/achievement.png": 1370,
	"./personal/aquarium.png": 1371,
	"./personal/background.png": 1372,
	"./personal/big_coin.png": 602,
	"./personal/blackboard.png": 1373,
	"./personal/capsule_machine.png": 1374,
	"./personal/coin/cn/b0.png": 603,
	"./personal/coin/cn/b1.png": 604,
	"./personal/coin/cn/b1s.png": 605,
	"./personal/coin/cn/b2.png": 606,
	"./personal/coin/cn/b3.png": 919,
	"./personal/coin/cn/b4.png": 607,
	"./personal/coin/cn/function.png": 920,
	"./personal/coin/cn/function_hk.png": 921,
	"./personal/coin/cn/reward_activities.png": 922,
	"./personal/coin/english/b0.png": 608,
	"./personal/coin/english/b1.png": 609,
	"./personal/coin/english/b2.png": 610,
	"./personal/coin/english/b3.png": 923,
	"./personal/coin/english/b4.png": 611,
	"./personal/coin/english/function.png": 924,
	"./personal/coin/english/function_hk.png": 925,
	"./personal/coin/english/reward_activities.png": 926,
	"./personal/coin/zh/b0.png": 612,
	"./personal/coin/zh/b1.png": 613,
	"./personal/coin/zh/b2.png": 614,
	"./personal/coin/zh/b3.png": 927,
	"./personal/coin/zh/b4.png": 615,
	"./personal/coin/zh/function.png": 928,
	"./personal/coin/zh/function_hk.png": 929,
	"./personal/coin/zh/reward_activities.png": 930,
	"./personal/efun.png": 1375,
	"./personal/header_background.png": 1376,
	"./personal/header_cat.png": 931,
	"./personal/main_background.png": 1377,
	"./personal/menu/achievement.png": 932,
	"./personal/menu/coin.png": 933,
	"./personal/menu/favorite.png": 934,
	"./personal/menu/game.png": 935,
	"./personal/menu/history.png": 936,
	"./personal/menu/intranet.png": 937,
	"./personal/menu/logout.png": 491,
	"./personal/menu/meetings.png": 938,
	"./personal/menu/personal.png": 939,
	"./personal/menu/redeem.png": 940,
	"./personal/menu/setting.png": 941,
	"./personal/menu/statistics.png": 942,
	"./personal/personal/person.png": 943,
	"./personal/personal/relationship_bg.png": 1378,
	"./personal/personal/useTime_bg.png": 1379,
	"./personal/user.png": 944,
	"./phone.png": 1380,
	"./rankb.png": 671,
	"./rankb1.png": 1381,
	"./rankb2.png": 1382,
	"./rankb3.png": 1383,
	"./rankm.png": 1384,
	"./rankt.png": 672,
	"./redemption/logo.png": 673,
	"./reportv2/background.png": 1385,
	"./resource/animal.png": 945,
	"./resource/community.png": 946,
	"./resource/family.png": 947,
	"./resource/food.png": 948,
	"./resource/green.png": 949,
	"./resource/health.png": 950,
	"./resource/help.png": 951,
	"./resource/icon/audio.png": 616,
	"./resource/icon/document.png": 617,
	"./resource/icon/download.png": 618,
	"./resource/icon/file.png": 619,
	"./resource/icon/img_cartoon.png": 620,
	"./resource/icon/img_line_graph.png": 621,
	"./resource/icon/img_real.png": 622,
	"./resource/icon/jttw360.png": 623,
	"./resource/icon/learn.png": 624,
	"./resource/icon/news.png": 625,
	"./resource/icon/science.png": 626,
	"./resource/icon/song_english.png": 627,
	"./resource/icon/song_zh.png": 628,
	"./resource/icon/storybook_video.png": 629,
	"./resource/icon/teach_guide.png": 630,
	"./resource/icon/treehouse.png": 631,
	"./resource/icon/video.png": 632,
	"./resource/mc/A.png": 633,
	"./resource/mc/B.png": 634,
	"./resource/mc/C.png": 635,
	"./resource/mc/D.png": 636,
	"./resource/mc/audio.png": 492,
	"./resource/mc/audio_img/confirm_cn.png": 493,
	"./resource/mc/audio_img/confirm_english.png": 494,
	"./resource/mc/audio_img/confirm_zh.png": 495,
	"./resource/mc/audio_img/question_cn.png": 496,
	"./resource/mc/audio_img/question_english.png": 497,
	"./resource/mc/audio_img/question_zh.png": 498,
	"./resource/mc/bg.png": 499,
	"./resource/mc/close.svg": 683,
	"./resource/mc/cn.png": 637,
	"./resource/mc/en.png": 638,
	"./resource/mc/idea.png": 500,
	"./resource/mc/rainbow.png": 501,
	"./resource/mc/son.png": 502,
	"./resource/mc/tick.webp": 994,
	"./resource/mc/video_img/answer_cn.png": 503,
	"./resource/mc/video_img/answer_english.png": 504,
	"./resource/mc/video_img/answer_zh.png": 505,
	"./resource/mc/video_img/question_cn.png": 506,
	"./resource/mc/video_img/question_english.png": 507,
	"./resource/mc/video_img/question_zh.png": 508,
	"./resource/mc/wrong.webp": 995,
	"./resource/mc/zh.png": 639,
	"./resource/mc/zh_cn.png": 640,
	"./resource/mc/zh_tw.png": 641,
	"./resource/nature.png": 952,
	"./resource/school.png": 953,
	"./resource/transport.png": 954,
	"./right_arrow.svg": 2539,
	"./schoolCourse/btn_icon_01.png": 674,
	"./schoolCourse/btn_icon_02.png": 675,
	"./schoolCourse/btn_icon_03.png": 676,
	"./schoolCourse/cn/highlight_title.png": 1386,
	"./schoolCourse/cn/highlight_title_cn.png": 1387,
	"./schoolCourse/english/highlight_title.png": 1388,
	"./schoolCourse/featured_works.png": 955,
	"./schoolCourse/finish_icon.png": 677,
	"./schoolCourse/highlight/icon_01.svg": 996,
	"./schoolCourse/highlight/icon_02.svg": 997,
	"./schoolCourse/highlight/icon_03.svg": 998,
	"./schoolCourse/highlight/icon_04.svg": 651,
	"./schoolCourse/highlight/medal.svg": 999,
	"./schoolCourse/highlight/medal_01.png": 1389,
	"./schoolCourse/highlight/medal_02.png": 1390,
	"./schoolCourse/highlight/medal_03.png": 1391,
	"./schoolCourse/highlight/video.svg": 1000,
	"./schoolCourse/hot_icon.png": 678,
	"./schoolCourse/icon/audio.png": 956,
	"./schoolCourse/icon/course.png": 957,
	"./schoolCourse/icon/document.png": 958,
	"./schoolCourse/icon/download.png": 959,
	"./schoolCourse/icon/eval.png": 960,
	"./schoolCourse/icon/eval_no_border.png": 642,
	"./schoolCourse/icon/file.png": 961,
	"./schoolCourse/icon/img_cartoon.png": 962,
	"./schoolCourse/icon/img_line_graph.png": 963,
	"./schoolCourse/icon/img_real.png": 964,
	"./schoolCourse/icon/jttw360.png": 965,
	"./schoolCourse/icon/learn.png": 966,
	"./schoolCourse/icon/news.png": 967,
	"./schoolCourse/icon/project.png": 968,
	"./schoolCourse/icon/project_no_border.png": 643,
	"./schoolCourse/icon/science.png": 969,
	"./schoolCourse/icon/song_english.png": 970,
	"./schoolCourse/icon/song_zh.png": 971,
	"./schoolCourse/icon/storybook_video.png": 972,
	"./schoolCourse/icon/treehouse.png": 973,
	"./schoolCourse/icon/video.png": 974,
	"./schoolCourse/no_submitted.png": 975,
	"./schoolCourse/progress_icon.png": 679,
	"./schoolCourse/soon_icon.png": 680,
	"./schoolCourse/video_bg.png": 654,
	"./schoolCourse/zh/highlight_title.png": 1392,
	"./schoolclass.png": 1393,
	"./special.png": 1394,
	"./spinner/spinner1.png": 976,
	"./spinner/spinner2.png": 977,
	"./spinner/spinner3.png": 978,
	"./spinner/spinner4.png": 979,
	"./time.png": 1395,
	"./traffic_bar_bg.jpg": 2540,
	"./user.png": 1396,
	"./zoomCalendar/logo.png": 681,
	"./zoomCalendar/zoom.png": 267,
	"./志雄科技LOGO_外部白框.png": 682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 514;